(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vima-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vima-product-tabs')) {
    customElements.define('vima-product-tabs', class VimaProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-vima-products-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-vima-products-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }

      onKeydown(event, index) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.activate(nextIndex, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vima-size-results"]) return;
  try {
    
  document.querySelectorAll('[data-vima-size-results]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const params = new URLSearchParams(window.location.search);
    const rawMeasure = params.get('mesure') || '';
    const measure = Number.parseFloat(rawMeasure.replace(',', '.'));
    const input = section.querySelector('[data-vima-results-input]');
    const grid = section.querySelector('[data-vima-results-grid]');
    const summary = section.querySelector('[data-vima-results-summary]');
    const empty = section.querySelector('[data-vima-results-empty]');
    const currency = section.dataset.currency || 'EUR';
    const nativeFilters = section.querySelector('[data-vima-native-filters]');
    const activeFilters = section.querySelector('[data-vima-active-filters]');
    const activeList = section.querySelector('[data-vima-active-list]');
    const visual = section.querySelector('.vima-results__visual');
    const measureRecap = section.querySelector('[data-vima-measure-recap]');
    const measureValue = section.querySelector('[data-vima-measure-value]');
    const editMeasure = section.querySelector('[data-vima-edit-measure]');
    const productSheet = section.querySelector('[data-vima-product-sheet]');
    const productSheetContent = section.querySelector('[data-vima-product-sheet-content]');
    const productSheetLoading = section.querySelector('[data-vima-product-sheet-loading]');
    let previousPageStyles = null;
    let previousScrollY = 0;
    let previousProductTrigger = null;
    let productSheetRequest = 0;
    let reviewWidgetManager = null;
    let reviewAssetsPromise = null;

    if (input && rawMeasure) input.value = rawMeasure.replace(',', '.');

    if (Number.isFinite(measure) && visual && measureRecap) {
      visual.hidden = true;
      measureRecap.hidden = false;
      if (measureValue) measureValue.textContent = measure.toLocaleString('fr-FR', { maximumFractionDigits: 1 });

      requestAnimationFrame(() => {
        measureRecap.scrollIntoView({ block: 'start' });
      });
    }

    if (editMeasure && visual && measureRecap) {
      editMeasure.addEventListener('click', () => {
        measureRecap.hidden = true;
        visual.hidden = false;
        requestAnimationFrame(() => {
          visual.scrollIntoView({ block: 'start', behavior: 'smooth' });
          input?.focus({ preventScroll: true });
          input?.select();
        });
      });
    }

    const activeWidthFilters = [];
    const activeThicknessFilters = [];
    params.forEach((value, key) => {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey.includes('largeur_du_pied')) activeWidthFilters.push(String(value).toLowerCase());
      if (normalizedKey.includes('epaisseur_du_pied')) activeThicknessFilters.push(String(value).toLowerCase());
    });

    const friendlyFilterLabel = (key, value) => {
      const k = key.toLowerCase();
      if (k.includes('largeur_du_pied')) return `Largeur du pied : ${String(value).toLowerCase()}`;
      if (k.includes('epaisseur_du_pied')) return `Épaisseur du pied : ${String(value).toLowerCase()}`;
      if (k.includes('saison')) return `Saison : ${value}`;
      if (k.includes('vendor')) return `Marque : ${value}`;
      if (k.includes('availability')) return `Disponibilité : ${value}`;
      if (k.includes('price.gte')) return `Prix min. : ${value}`;
      if (k.includes('price.lte')) return `Prix max. : ${value}`;
      return String(value);
    };

    if (activeFilters && activeList) {
      const entries = Array.from(params.entries()).filter(([key]) => key.startsWith('filter.'));
      entries.forEach(([key, value], entryIndex) => {
        const next = new URLSearchParams(params);
        const allValues = params.getAll(key);
        next.delete(key);
        let skipped = false;
        allValues.forEach((candidate) => {
          if (!skipped && candidate === value) {
            skipped = true;
            return;
          }
          next.append(key, candidate);
        });
        next.set('view', 'pointure');
        if (rawMeasure) next.set('mesure', rawMeasure);

        const chip = document.createElement('a');
        chip.className = 'vima-results__active-chip';
        chip.href = `${window.location.pathname}?${next.toString()}`;
        chip.textContent = friendlyFilterLabel(key, value);
        const close = document.createElement('span');
        close.setAttribute('aria-hidden', 'true');
        close.textContent = '×';
        chip.appendChild(close);
        activeList.appendChild(chip);
      });
      activeFilters.hidden = entries.length === 0;
    }

    if (nativeFilters) {
      const applyCalculatorFilters = (form) => {
        const next = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (String(value).trim()) next.append(key, value);
        });
        next.set('view', 'pointure');
        if (rawMeasure) next.set('mesure', rawMeasure);
        if (params.has('preview_theme_id')) next.set('preview_theme_id', params.get('preview_theme_id'));
        next.delete('page');
        next.delete('section_id');
        window.location.assign(`${window.location.pathname}?${next.toString()}`);
      };

      // This custom grid is rendered from the collection, not Dawn's ProductGridContainer.
      nativeFilters.addEventListener('input', (event) => {
        event.stopPropagation();
        if (event.target.matches('select[name="sort_by"]')) {
          applyCalculatorFilters(event.target.closest('form'));
        }
      }, true);
      nativeFilters.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        applyCalculatorFilters(event.target);
      }, true);
      nativeFilters.addEventListener('click', (event) => {
        const applyButton = event.target.closest('.mobile-facets__footer .button--primary');
        if (applyButton) {
          event.preventDefault();
          event.stopPropagation();
          applyCalculatorFilters(applyButton.closest('form'));
          return;
        }
        const link = event.target.closest('facet-remove a[href]');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(link.href);
      }, true);

      nativeFilters.querySelectorAll('form').forEach((form) => {
        let viewInput = form.querySelector('input[name="view"]');
        if (!viewInput) {
          viewInput = document.createElement('input');
          viewInput.type = 'hidden';
          viewInput.name = 'view';
          form.appendChild(viewInput);
        }
        viewInput.value = 'pointure';

        let measureInput = form.querySelector('input[name="mesure"]');
        if (!measureInput) {
          measureInput = document.createElement('input');
          measureInput.type = 'hidden';
          measureInput.name = 'mesure';
          form.appendChild(measureInput);
        }
        measureInput.value = rawMeasure;

        form.querySelectorAll('.mobile-facets__footer .button--primary').forEach((button) => {
          button.type = 'submit';
          button.removeAttribute('onclick');
        });
      });

      nativeFilters.querySelectorAll('a[href]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('view', 'pointure');
          if (rawMeasure) url.searchParams.set('mesure', rawMeasure);
          link.href = url.pathname + url.search + url.hash;
        } catch (error) {
          /* Keep the original Shopify link if it cannot be parsed. */
        }
      });
    }

    if (!grid || !summary || !empty) return;

    const parseSizing = (label) => {
      const text = String(label || '');
      const range = text.match(/\(([\d,.]+)\s*[–-]\s*([\d,.]+)\s*cm\)/i);
      if (range) {
        return {
          mode: 'range',
          min: Number.parseFloat(range[1].replace(',', '.')),
          max: Number.parseFloat(range[2].replace(',', '.'))
        };
      }
      const limit = text.match(/\(\s*<\s*([\d,.]+)\s*cm\)/i);
      if (limit) {
        return {
          mode: 'limit',
          max: Number.parseFloat(limit[1].replace(',', '.'))
        };
      }
      return null;
    };

    const cleanSize = (label) => String(label || '').split('(')[0].trim();
    const money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency });

    const closeProductSheet = () => {
      if (!productSheet || productSheet.hidden) return;
      productSheetRequest += 1;
      productSheet.dispatchEvent(new Event('vima:product-sheet-close'));
      reviewWidgetManager?.widget?.app?.unmount();
      reviewWidgetManager = null;
      document.querySelectorAll('.jdgm-write-review-modal').forEach((modal) => modal.remove());
      if (productSheetContent) productSheetContent.replaceChildren();
      productSheet.querySelector('.vima-product-sheet__panel')?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      productSheet.hidden = true;
      if (previousPageStyles) {
        Object.entries(previousPageStyles.body).forEach(([key, value]) => { document.body.style[key] = value; });
        document.documentElement.style.overflow = previousPageStyles.htmlOverflow;
        previousPageStyles = null;
        window.scrollTo({ top: previousScrollY, left: 0, behavior: 'instant' });
      }
      previousProductTrigger?.focus({ preventScroll: true });
      if (productSheetLoading) {
        productSheetLoading.hidden = false;
        productSheetLoading.textContent = 'Chargement de la fiche produit…';
      }
    };

    section.querySelectorAll('[data-vima-product-sheet-close]').forEach((button) => {
      button.addEventListener('click', closeProductSheet);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && productSheet && !productSheet.hidden) closeProductSheet();
    });

    const stripProductZoomWrappers = (root) => {
      root.querySelectorAll('.skip-to-content-link').forEach((node) => node.remove());

      root.querySelectorAll('modal-opener.product__modal-opener').forEach((opener) => {
        opener.querySelectorAll('.product__media-toggle, .product__media-icon').forEach((node) => node.remove());

        const replacement = document.createElement('div');
        replacement.className = 'vima-static-product-media';
        while (opener.firstChild) replacement.appendChild(opener.firstChild);
        opener.replaceWith(replacement);
      });
    };

    const activeExternalScripts = new Set(
      Array.from(document.scripts)
        .map((script) => script.src)
        .filter(Boolean)
    );

    const activateProductScripts = (root) => {
      root.querySelectorAll('script').forEach((oldScript) => {
        const type = (oldScript.getAttribute('type') || '').toLowerCase();
        if (type && !['text/javascript', 'application/javascript', 'module'].includes(type)) return;
        if (oldScript.src && activeExternalScripts.has(oldScript.src)) {
          oldScript.remove();
          return;
        }

        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        if (!oldScript.src) {
          newScript.textContent = oldScript.textContent;
        } else {
          activeExternalScripts.add(oldScript.src);
        }
        oldScript.replaceWith(newScript);
      });
    };


    const loadReviewAssets = () => {
      if (reviewAssetsPromise) return reviewAssetsPromise;
      reviewAssetsPromise = (async () => {
        const base = window.jdgm?.CDN_BASE_URL;
        if (!base || !window.jdgm?.loadScript) throw new Error('review-loader-unavailable');
        const [manifest, entrySource] = await Promise.all([
          fetch(new URL('manifest.json', base)).then((response) => {
            if (!response.ok) throw new Error('review-styles-unavailable');
            return response.json();
          }),
          fetch(new URL('review_widget.js', base)).then((response) => {
            if (!response.ok) throw new Error('review-module-unavailable');
            return response.text();
          })
        ]);
        const visited = new Set();
        const stylePromises = [];
        const loadStyles = (key) => {
          if (visited.has(key)) return;
          visited.add(key);
          const entry = manifest[key];
          if (!entry) return;
          (entry.css || []).forEach((file) => {
            const href = new URL(file, base).href;
            if (Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((link) => link.href === href)) return;
            stylePromises.push(new Promise((resolve, reject) => {
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = href;
              link.onload = resolve;
              link.onerror = reject;
              document.head.appendChild(link);
            }));
          });
          (entry.imports || []).forEach(loadStyles);
        };
        loadStyles('review-widget/main.js');
        const managerImport = entrySource.match(/from\s*["']([^"']*ReviewWidgetManager[^"']*)["']/);
        if (!managerImport) throw new Error('review-manager-unavailable');
        const core = window.jdgm.$ ? Promise.resolve() : new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => reject(new Error('review-core-timeout')), 12000);
          window.jdgm.loadScript('widget/base.js', () => {
            window.jdgm.loadScript('widget/common.js', () => {
              window.clearTimeout(timeout);
              resolve();
            });
          });
        });
        window.jdgm.loadCSS(window.jdgm.widgetPath('base.css'));
        window.jdgm.loadCSS(window.jdgm.widgetPath('main.css'));
        const [module] = await Promise.all([
          import(new URL(managerImport[1], base).href),
          Promise.all(stylePromises),
          core
        ]);
        return module.ReviewWidgetManager;
      })().catch((error) => {
        reviewAssetsPromise = null;
        throw error;
      });
      return reviewAssetsPromise;
    };

    const initializeProductReviews = async (root, url, requestId) => {
      const widget = root.querySelector('.jdgm-review-widget[data-entry-point]');
      if (!widget) return;
      const fallback = document.createElement('a');
      fallback.href = url.pathname + url.search + '#judgeme';
      fallback.className = 'vima-result-card__link';
      fallback.textContent = window.jdgmSettings?.widget_open_form_text || 'Écrire un avis';
      widget.appendChild(fallback);
      try {
        const ReviewWidgetManager = await loadReviewAssets();
        if (requestId !== productSheetRequest || !widget.isConnected) return;
        const manager = new ReviewWidgetManager(widget);
        reviewWidgetManager = manager;
        await manager.initialize();
        if (requestId !== productSheetRequest || !widget.isConnected) manager.widget?.app?.unmount();
      } catch (error) {
        if (requestId !== productSheetRequest || !widget.isConnected) return;
        if (!widget.contains(fallback)) widget.appendChild(fallback);
      }
    };

    const productHtmlCache = new Map();
    const productFetches = new Map();

    const productSheetUrl = (group) => {
      const recommended = group.variants[group.variants.length - 1];
      const url = new URL(group.product.url, window.location.origin);
      url.searchParams.set('variant', recommended.id);
      url.searchParams.set('vima_from_calculator', '1');
      return url;
    };

    const fetchProductMainHtml = async (group) => {
      const url = productSheetUrl(group);
      const key = url.pathname + url.search;
      if (productHtmlCache.has(key)) return productHtmlCache.get(key);
      if (productFetches.has(key)) return productFetches.get(key);

      const promise = fetch(key, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
        .then((response) => {
          if (!response.ok) throw new Error('product-load-failed');
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const main = doc.querySelector('#MainContent');
          if (!main) throw new Error('product-main-missing');
          main.querySelectorAll('.jdgm-ssr-rating-distribution').forEach((distribution) => distribution.remove());
          const mainHtml = main.innerHTML;
          productHtmlCache.set(key, mainHtml);
          productFetches.delete(key);
          return mainHtml;
        })
        .catch((error) => {
          productFetches.delete(key);
          throw error;
        });

      productFetches.set(key, promise);
      return promise;
    };

    const prefetchProductSheet = (group) => {
      if (!group || !group.variants?.length) return;
      fetchProductMainHtml(group).catch(() => {});
    };

    const applyRecommendedVariant = (root, group) => {
      if (!root || !group || !group.variants?.length) return;
      const recommended = group.variants[group.variants.length - 1];
      const sourceVariant = Array.isArray(group.product.variants)
        ? group.product.variants.find((variant) => String(variant.id) === String(recommended.id))
        : null;
      const optionNames = Array.isArray(group.product.options) ? group.product.options : [];
      if (!sourceVariant || !Array.isArray(sourceVariant.options)) return;

      const applySelection = (dispatchChange = false) => {
        const currentPicker = root.querySelector('variant-selects');
        if (!currentPicker) return;

        currentPicker.classList.add('vima-size-confirmed');
        currentPicker.closest('product-info')?.setAttribute('data-vima-size-confirmed', 'true');

        let trigger = null;
        optionNames.forEach((optionName, index) => {
          const targetValue = String(sourceVariant.options[index] ?? '');
          if (!targetValue) return;

          const radios = Array.from(currentPicker.querySelectorAll('input[type="radio"][data-option-name]'))
            .filter((input) => input.dataset.optionName === optionName);
          const radio = radios.find((input) => String(input.value) === targetValue);
          if (radio) {
            radio.checked = true;
            trigger = radio;
            const fieldset = radio.closest('fieldset');
            const selectedLabel = fieldset?.querySelector('[data-selected-value]');
            if (selectedLabel) selectedLabel.textContent = targetValue;
          }

          currentPicker.querySelectorAll('select').forEach((select) => {
            const matchingOption = Array.from(select.options).find(
              (candidate) =>
                String(candidate.value) === targetValue ||
                (candidate.dataset.optionName === optionName && String(candidate.value) === targetValue)
            );
            if (matchingOption) {
              Array.from(select.options).forEach((candidate) => candidate.removeAttribute('selected'));
              matchingOption.selected = true;
              matchingOption.setAttribute('selected', 'selected');
              select.value = matchingOption.value;
              trigger = select;
            }
          });
        });

        const selectedNode = currentPicker.querySelector('[data-selected-variant]');
        if (selectedNode) selectedNode.textContent = JSON.stringify(sourceVariant);

        if (dispatchChange && trigger) {
          trigger.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const sizeTrack = currentPicker.querySelector('.vima-size-track');
        const checkedSize = sizeTrack?.querySelector('input[type="radio"]:checked');
        if (sizeTrack && checkedSize) {
          const label = sizeTrack.querySelector(`label[for="${CSS.escape(checkedSize.id)}"]`);
          if (label) {
            const targetLeft = label.offsetLeft - Math.max(0, (sizeTrack.clientWidth - label.offsetWidth) / 2);
            sizeTrack.scrollLeft = Math.max(0, targetLeft);
          }
        }
      };

      applySelection(false);
      [80, 250, 600, 1000].forEach((delay) => {
        window.setTimeout(() => applySelection(false), delay);
      });
    };

    const openProductSheet = async (group) => {
      if (!productSheet || !productSheetContent || !group || !group.variants.length) return;
      const requestId = ++productSheetRequest;
      const url = productSheetUrl(group);
      const cacheKey = url.pathname + url.search;
      const cachedHtml = productHtmlCache.get(cacheKey);

      if (productSheet.hidden) {
        previousScrollY = window.scrollY;
        previousProductTrigger = document.activeElement;
        previousPageStyles = {
          htmlOverflow: document.documentElement.style.overflow,
          body: Object.fromEntries(['overflow', 'position', 'top', 'left', 'width'].map((key) => [key, document.body.style[key]]))
        };
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${previousScrollY}px`;
        document.body.style.left = '0';
        document.body.style.width = '100%';
      }
      productSheet.hidden = false;
      productSheet.dispatchEvent(new Event('vima:product-sheet-close'));
      productSheetContent.innerHTML = '';

      if (productSheetLoading) {
        productSheetLoading.hidden = Boolean(cachedHtml);
        productSheetLoading.textContent = 'Chargement de la fiche produit…';
      }

      try {
        const mainHtml = cachedHtml || await fetchProductMainHtml(group);
        if (requestId !== productSheetRequest) return;

        productSheetContent.innerHTML = mainHtml;
        stripProductZoomWrappers(productSheetContent);
        activateProductScripts(productSheetContent);
        initializeProductReviews(productSheetContent, url, requestId);
        const productPanel = productSheet.querySelector('.vima-product-sheet__panel');
        window.requestAnimationFrame(() => {
          window.VimaSizeFinder?.sync?.();
          applyRecommendedVariant(productSheetContent, group);
          window.requestAnimationFrame(() => window.VimaSizeFinder?.sync?.());
          productPanel?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        });

        if (productSheetLoading) productSheetLoading.hidden = true;
        productPanel?.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      } catch (error) {
        if (requestId !== productSheetRequest) return;
        if (productSheetLoading) {
          productSheetLoading.hidden = false;
          productSheetLoading.innerHTML = '';
          const message = document.createElement('div');
          message.textContent = 'La fiche produit n’a pas pu être chargée.';
          const fallback = document.createElement('a');
          fallback.href = url.pathname + url.search;
          fallback.className = 'button';
          fallback.style.marginTop = '1.2rem';
          fallback.textContent = 'Ouvrir la fiche produit';
          productSheetLoading.append(message, fallback);
        }
      }
    };

    const groups = new Map();

    if (!Number.isFinite(measure)) {
      summary.textContent = 'Indiquez la longueur du pied pour afficher les pointures recommandées.';
      empty.hidden = true;
      return;
    }

    section.querySelectorAll('[data-vima-size-product]').forEach((node) => {
      let product;
      try {
        product = JSON.parse(node.textContent);
      } catch (error) {
        return;
      }

      const optionNames = Array.isArray(product.options) ? product.options : [];
      const sizeIndex = optionNames.findIndex((name) => /pointure|taille/i.test(name));
      const colorIndex = optionNames.findIndex((name) => /couleur|color/i.test(name));
      if (sizeIndex < 0 || !Array.isArray(product.variants)) return;

      const byColor = new Map();

      product.variants.forEach((variant) => {
        if (!Array.isArray(variant.options)) return;
        const sizeLabel = variant.options[sizeIndex];
        const sizing = parseSizing(sizeLabel);
        if (!sizing) return;

        const color = colorIndex >= 0 ? variant.options[colorIndex] : 'Modèle disponible';
        const image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url)
          ? (variant.featured_image.src || variant.featured_image.url)
          : product.fallbackImage;

        const item = {
          id: variant.id,
          size: cleanSize(sizeLabel),
          sizing,
          max: sizing.max,
          available: Boolean(variant.available),
          price: Number(variant.price || 0) / 100,
          image
        };

        if (!byColor.has(color)) byColor.set(color, []);
        byColor.get(color).push(item);
      });

      const matchesMorphology = (variantId) => {
        const profile = product.variantMorphology
          ? product.variantMorphology[String(variantId)] || {}
          : {};
        const widthValues = Array.isArray(profile.width) && profile.width.length
          ? profile.width
          : product.widthProfile;
        const thicknessValues = profile.hasThickness === true
          ? profile.thickness
          : product.thicknessProfile;
        const widths = Array.isArray(widthValues) ? widthValues.map((value) => String(value).toLowerCase()) : [];
        const thicknesses = Array.isArray(thicknessValues) ? thicknessValues.map((value) => String(value).toLowerCase()) : [];

        const widthOkay = !activeWidthFilters.length || activeWidthFilters.some((value) => widths.includes(value));
        const thicknessOkay = !activeThicknessFilters.length || activeThicknessFilters.some((value) => thicknesses.includes(value));
        return widthOkay && thicknessOkay;
      };

      byColor.forEach((variants, color) => {
        const morphologyCompatible = variants.filter((item) => matchesMorphology(item.id));
        const explicitMatches = morphologyCompatible
          .filter((item) => item.sizing.mode === 'range' && item.available && measure >= item.sizing.min && measure <= item.sizing.max)
          .sort((a, b) => a.max - b.max);

        const limitVariants = morphologyCompatible
          .filter((item) => item.sizing.mode === 'limit')
          .sort((a, b) => a.max - b.max);

        const limitTarget = limitVariants.find((item) => measure < item.max);
        const matches = explicitMatches.slice();
        if (limitTarget && limitTarget.available) matches.push(limitTarget);

        if (!matches.length) return;

        const key = `${product.id}-${color}`;
        groups.set(key, { product, color, variants: matches.sort((a, b) => a.max - b.max) });
      });
    });

    const results = Array.from(groups.values());
    const seasonalRank = (group) => {
      const text = `${group.product.title || ''} ${group.product.url || ''}`.toLowerCase();

      if (/piscine|plage|sandale/.test(text)) return 3;
      if (/botte|pluie|chaussons physiologiques|chaussons-chaussettes|teddy|fluffy/.test(text)) return 0;
      if (/basket|tennis|lona/.test(text)) return 1;
      return 2;
    };

    results.sort((a, b) =>
      seasonalRank(a) - seasonalRank(b) ||
      a.product.title.localeCompare(b.product.title, 'fr') ||
      a.color.localeCompare(b.color, 'fr')
    );

    if (!results.length) {
      summary.textContent = `Aucune pointure disponible pour un pied de ${measure.toLocaleString('fr-FR')} cm.`;
      empty.hidden = false;
      return;
    }

    summary.textContent = `${results.length} résultat${results.length > 1 ? 's' : ''} compatible${results.length > 1 ? 's' : ''} pour un pied de ${measure.toLocaleString('fr-FR')} cm.`;
    empty.hidden = true;

    const warmProductCache = () => {
      results.slice(0, 2).forEach((group, index) => {
        window.setTimeout(() => prefetchProductSheet(group), index * 180);
      });
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmProductCache, { timeout: 1200 });
    } else {
      window.setTimeout(warmProductCache, 350);
    }

    results.forEach((group) => {
      const recommended = group.variants[group.variants.length - 1];
      const card = document.createElement('article');
      card.className = 'vima-result-card';

      const media = document.createElement('a');
      media.className = 'vima-result-card__media';
      const productUrl = productSheetUrl(group);
      media.href = productUrl.pathname + productUrl.search + productUrl.hash;
      const image = document.createElement('img');
      image.src = recommended.image;
      image.alt = `${group.product.title} – ${group.color}`;
      image.loading = 'lazy';
      media.appendChild(image);

      const profileLabel = (values, kind) => {
        if (!Array.isArray(values) || !values.length) return '';
        const n = values.map((value) => String(value).toLowerCase());
        if (kind === 'width') {
          if (n.includes('fine') && n.includes('moyenne') && n.includes('large')) return 'Largeur du pied : fine à large';
          if (n.includes('fine') && n.includes('moyenne')) return 'Largeur du pied : fine à moyenne';
          if (n.includes('moyenne') && n.includes('large')) return 'Largeur du pied : moyenne à large';
          if (n.includes('fine')) return 'Largeur du pied : fine';
          if (n.includes('large')) return 'Largeur du pied : large';
          if (n.includes('moyenne')) return 'Largeur du pied : moyenne';
        } else {
          if (n.includes('faible') && n.includes('moyenne') && n.includes('forte')) return 'Épaisseur du pied : faible à forte';
          if (n.includes('faible') && n.includes('moyenne')) return 'Épaisseur du pied : faible à moyenne';
          if (n.includes('moyenne') && n.includes('forte')) return 'Épaisseur du pied : moyenne à forte';
          if (n.includes('faible')) return 'Épaisseur du pied : faible';
          if (n.includes('forte')) return 'Épaisseur du pied : forte';
          if (n.includes('moyenne')) return 'Épaisseur du pied : moyenne';
        }
        return '';
      };

      const variantProfile = group.product.variantMorphology
        ? group.product.variantMorphology[String(recommended.id)] || {}
        : {};
      const widthValues = Array.isArray(variantProfile.width) && variantProfile.width.length
        ? variantProfile.width
        : group.product.widthProfile;
      const thicknessValues = variantProfile.hasThickness === true
        ? variantProfile.thickness
        : group.product.thicknessProfile;
      const widthLabel = profileLabel(widthValues, 'width');
      const thicknessLabel = profileLabel(thicknessValues, 'thickness');
      let profile = null;
      if (widthLabel || thicknessLabel) {
        profile = document.createElement('div');
        profile.className = 'vima-result-card__profile';
        [widthLabel, thicknessLabel].filter(Boolean).forEach((label, index) => {
          const badge = document.createElement('span');
          badge.className = `vima-result-card__profile-badge${index === 0 ? ' vima-result-card__profile-badge--primary' : ''}`;
          badge.textContent = label;
          profile.appendChild(badge);
        });
      }

      const content = document.createElement('div');
      content.className = 'vima-result-card__content';
      const title = document.createElement('h2');
      title.className = 'vima-result-card__title';
      let cardDisplayTitle = group.product.displayTitle || group.product.title;
      const colourName = String(group.color || '').toLowerCase();
      if (String(group.product.id) === '16113356833093') {
        if (colourName.startsWith('pau ')) cardDisplayTitle = 'PAU';
        if (colourName.startsWith('yogi ')) cardDisplayTitle = 'Yogi Borreguito';
      }
      if (String(group.product.id) === '15206607618373') {
        if (colourName.includes('velcro')) cardDisplayTitle = 'Coton velcro';
        if (colourName.includes('bouton')) cardDisplayTitle = 'Coton bouton';
      }
      if (String(group.product.id) === '15695632302405') {
        if (colourName.includes('velcro')) cardDisplayTitle = 'Fluffy scratch';
        if (colourName.includes('élastique') || colourName.includes('elastique')) cardDisplayTitle = 'Fluffy élastique';
      }
      title.textContent = cardDisplayTitle;
      const vendor = document.createElement('p');
      vendor.className = 'vima-result-card__vendor';
      vendor.textContent = group.product.vendor || '';
      const color = document.createElement('p');
      color.className = 'vima-result-card__color';
      color.textContent = group.color;
      const sizes = document.createElement('div');
      sizes.className = 'vima-result-card__sizes';
      group.variants.forEach((variant, index) => {
        const size = document.createElement('span');
        const isRecommended = index === group.variants.length - 1;
        size.className = `vima-result-card__size${isRecommended ? ' vima-result-card__size--recommended' : ''}`;
        size.textContent = group.variants.length > 1 && isRecommended
          ? `${variant.size} conseillée`
          : `Pointure ${variant.size}`;
        sizes.appendChild(size);
      });
      const footer = document.createElement('div');
      footer.className = 'vima-result-card__footer';
      const price = document.createElement('span');
      price.className = 'vima-result-card__price';
      price.textContent = money.format(recommended.price);
      const openPreview = (event) => {
        event.preventDefault();
        openProductSheet(group);
      };
      media.addEventListener('click', openPreview);
      media.addEventListener('pointerdown', () => prefetchProductSheet(group), { once: true, passive: true });
      media.addEventListener('touchstart', () => prefetchProductSheet(group), { once: true, passive: true });

      const link = document.createElement('a');
      link.className = 'vima-result-card__link';
      link.href = productUrl.pathname + productUrl.search + productUrl.hash;
      link.textContent = 'Voir ce modèle';
      link.addEventListener('click', openPreview);
      link.addEventListener('pointerdown', () => prefetchProductSheet(group), { once: true, passive: true });
      link.addEventListener('touchstart', () => prefetchProductSheet(group), { once: true, passive: true });
      footer.append(price, link);
      content.append(title);
      if (vendor.textContent) content.appendChild(vendor);
      content.appendChild(color);
      if (profile) content.appendChild(profile);
      content.append(sizes, footer);
      card.append(media, content);
      grid.appendChild(card);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vima-virtual-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cleanColor = (value) => String(value || '').replace(/^(PAU|YOGI)\s+/i, '').trim();

  document.querySelectorAll('[data-vima-virtual-product]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    const data = root.querySelector('[data-vima-virtual-variants]');
    const mediaData = root.querySelector('[data-vima-virtual-media]');
    if (!data || !mediaData) return;

    let variants = [];
    let mediaItems = [];
    try {
      variants = JSON.parse(data.textContent || '[]');
      mediaItems = JSON.parse(mediaData.textContent || '[]');
    } catch {
      return;
    }
    if (!variants.length) return;

    root.dataset.ready = 'true';
    const colorSelect = root.querySelector('[data-vima-color]');
    const sizeSelect = root.querySelector('[data-vima-size]');
    const price = root.querySelector('[data-vima-price]');
    const stock = root.querySelector('[data-vima-stock]');
    const add = root.querySelector('[data-vima-add]');
    const mainImage = root.querySelector('[data-vima-main-image]');
    const thumbs = root.querySelector('[data-vima-thumbs]');

    [...new Set(variants.map((variant) => variant.color))].forEach((color) => {
      const option = document.createElement('option');
      option.value = color;
      option.textContent = cleanColor(color);
      colorSelect.appendChild(option);
    });

    const rebuildSizes = () => {
      const currentSize = sizeSelect.value;
      const colorVariants = variants.filter((variant) => variant.color === colorSelect.value);
      const sizes = [...new Set(colorVariants.map((variant) => variant.size))];
      sizeSelect.replaceChildren();
      sizes.forEach((size) => {
        const matching = colorVariants.find((variant) => variant.size === size);
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size;
        option.disabled = !matching?.available;
        sizeSelect.appendChild(option);
      });
      if (sizes.includes(currentSize)) sizeSelect.value = currentSize;
      if (!sizeSelect.value || sizeSelect.selectedOptions[0]?.disabled) {
        const available = Array.from(sizeSelect.options).find((option) => !option.disabled);
        if (available) sizeSelect.value = available.value;
      }
    };

    const selectedVariant = () => variants.find((variant) => variant.color === colorSelect.value && variant.size === sizeSelect.value);

    const setMainImage = (src, alt = '') => {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
    };

    const rebuildGallery = () => {
      if (!thumbs) return;
      const colorKey = String(colorSelect.value || '').toLowerCase();
      const colorMedia = mediaItems.filter((media) => !media.common && media.altLower.includes(colorKey));
      const commonMedia = mediaItems.filter((media) => media.common);
      const gallery = [...colorMedia, ...commonMedia];

      thumbs.replaceChildren();

      gallery.forEach((media, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'vima-virtual-product__thumb';
        button.dataset.vimaThumb = '';
        button.dataset.image = media.image;
        button.dataset.alt = media.alt || '';
        button.setAttribute('aria-label', media.alt || 'Voir la photo');

        const image = document.createElement('img');
        image.src = media.thumb;
        image.alt = media.alt || '';
        image.loading = index < 4 ? 'eager' : 'lazy';
        if (media.width) image.width = media.width;
        if (media.height) image.height = media.height;

        button.appendChild(image);
        thumbs.appendChild(button);
      });

      const first = colorMedia[0] || gallery[0];
      const variant = selectedVariant();
      if (first) {
        setMainImage(first.image, first.alt);
      } else if (variant?.image) {
        setMainImage(variant.image);
      }
    };

    const refresh = () => {
      const variant = selectedVariant();
      if (!variant) return;
      price.textContent = variant.priceFormatted;
      stock.textContent = variant.available ? '' : 'Rupture de stock';
      add.disabled = !variant.available;
      if (variant.image && mainImage && !thumbs?.children.length) {
        setMainImage(variant.image);
      }
    };

    colorSelect.value = variants[0].color;
    rebuildSizes();
    refresh();
    rebuildGallery();

    colorSelect.addEventListener('change', () => {
      rebuildSizes();
      refresh();
      rebuildGallery();
    });
    sizeSelect.addEventListener('change', refresh);

    thumbs?.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-vima-thumb]');
      if (!thumb || !thumbs.contains(thumb)) return;
      setMainImage(thumb.dataset.image, thumb.dataset.alt || '');
    });

    add.addEventListener('click', async () => {
      const variant = selectedVariant();
      if (!variant?.available) return;
      add.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) throw new Error('add');
        const state = await response.json();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections) drawer.renderContents(state);
      } catch {
        window.location.href = '/cart';
      } finally {
        add.disabled = false;
        refresh();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
